import React, { useState } from "react";
import TransactionFlowDefaultTemplate from "../../others/transactionFlowDefaultTemplate";
import dayjs from "dayjs";
import { Tag, Tooltip } from "antd";
import {
  FileTextOutlined,
  FolderOpenOutlined,
  FolderOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router";

const TenderEvaluation = () => {
  const navigate = useNavigate();
  const columns = [
    {
      title: "Tender ID",
      dataIndex: "tenderNumber",
      key: "tenderNumber",
      fixed: "left",
      width: 170,
      render(text: any, record: any) {
        return (
          <Tooltip title="Click To View Evaluation Details">
            <span
              className="inlineTableCellLink"
              onClick={() => {
                navigate(`/tender-evaluation/${record.tenderId}`, {
                  state: { tenderNumber: record.tenderNumber },
                });
              }}
            >
              {text}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: "Title",
      dataIndex: "tenderTitle",
      key: "tenderTitle",
      render: (text: string) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 200,
              display: "inline-block",
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Type",
      dataIndex: "tenderType",
      key: "tenderType",
      width: 130,
      render: (type: string) => (
        <Tag
          color={type === "Open" ? "green" : "blue"}
          icon={type === "Open" ? <FolderOpenOutlined /> : <FolderOutlined />}
        >
          {type}
        </Tag>
      ),
    },
    {
      title: "Tender For",
      dataIndex: "tenderFor",
      width: 130,
      key: "tenderFor",
      render: (tenderFor: string) => (
        <Tag color={tenderFor === "Material" ? "purple" : "cyan"}>
          {tenderFor}
        </Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (status: string) => (
        <Tag color="purple" icon={<FileTextOutlined />}>
          {status}
        </Tag>
      ),
    },
    {
      title: "Site / Project",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
      render: (text: string) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 160,
              display: "inline-block",
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "EOI Deadline",
      dataIndex: "lastDateForExpressingInterest",
      key: "lastDateForExpressingInterest",
      render: (date: any) => (date ? dayjs(date).format("DD-MMM-YYYY") : "--"),
      width: 120,
    },
    {
      title: "Submission Deadline",
      dataIndex: "lastSubmissionDate",
      key: "lastSubmissionDate",
      render: (date: any) => (date ? dayjs(date).format("DD-MMM-YYYY") : "--"),
      width: 160,
    },
  ];

  return (
    <TransactionFlowDefaultTemplate
      moduleKey="tender-evaluation"
      title="Tender Evaluation"
      columns={columns}
      selectFilters={[
        {
          title: "Status",
          placeholder: "Select Status",
          options: [
            { value: "All", label: "All" },
            { value: "Under Evaluation", label: "Under Evaluation" },
          ],
        },
      ]}
      extra={{
        tableScrollX: 1100,
        dateRange: false,
        excelExport: false,
      }}
    />
  );
};

export default TenderEvaluation;
